import script from "./TimeAndCalendar.vue?vue&type=script&lang=ts&setup=true"
export * from "./TimeAndCalendar.vue?vue&type=script&lang=ts&setup=true"

import "./TimeAndCalendar.vue?vue&type=style&index=0&id=c7d9b1d8&lang=scss&scoped=true"

import exportComponent from "/Users/ttheitao/Desktop/devApps/onetab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c7d9b1d8"]])

export default __exports__